import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// keep token for image URLs (img tag can't send credentials cookie reliably in some prev envs)
let sessionToken = null;
export const setSessionToken = (t) => {
  sessionToken = t;
  if (t) localStorage.setItem("st", t);
  else localStorage.removeItem("st");
};
export const getSessionToken = () => {
  if (sessionToken) return sessionToken;
  const t = localStorage.getItem("st");
  if (t) sessionToken = t;
  return sessionToken;
};

api.interceptors.request.use((config) => {
  const t = getSessionToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const imageUrl = (path) => {
  const t = getSessionToken();
  const qp = new URLSearchParams({ path });
  if (t) qp.set("auth", t);
  return `${API}/image?${qp.toString()}`;
};

export default api;
